/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_From_LabelInputs */

const en_admin_statistics_from_label = /** @type {(inputs: Admin_Statistics_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const de_admin_statistics_from_label = /** @type {(inputs: Admin_Statistics_From_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Admin_Statistics_From_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_from_label = /** @type {((inputs?: Admin_Statistics_From_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_From_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_from_label(inputs)
	return en_admin_statistics_from_label(inputs)
});